<template lang="html">
  <div class="modal-container">
    <!-- it's helpful to add a click event to a button-->
    <button class="plus" type="button" @click="$emit('show-modal')">
      <TodoIcon v-show="!showIcon" :icon="'add'"/>
    </button>
  </div>
</template>

<script>
import TodoIcon from '@/components/TodoIcon.vue';
import { parse } from 'date-fns';


export default {
  components: {
    TodoIcon,
  },
  data() {
    return {
      showIcon: false,
      todoBeingEdited: null, // this variable stores the todo to be edited, it is passed to the TodoModal as Prop
      activeView: null, // current active project
    };
  },
  computed: {
    // use date fns for displaying todays date, with an option to change it over an
    // input field in the modal
    dueDate: {
      get() {
        return parse('this.doneUntil', 'yyyy-MM-dd', new Date());
      },
      set(dueDate) {
        return dueDate;
      },
    },
  },
  methods: {
    async handleSave() {
      const {
        text, hoursTotal, hoursWorked, projectName, motiveText, dueDate, category,
      } = this;
      if (!text) return;
      if (!this.todo) {
        this.$emit('add', {
          text, hoursTotal, hoursWorked, projectName, motiveText, dueDate, category,
        });
        this.text = '';
        this.hoursTotal = '';
        this.hoursWorked = '';
        this.projectName = '';
        this.motiveText = '';
        this.dueDate = '';
        this.category = '';
        this.$store.commit('addToast', { message: 'Your rhythm has been added.' });
      } else {
        this.$emit('update', {
          text, hoursTotal, hoursWorked, projectName, motiveText, dueDate, category,
        });
        this.$store.commit('addToast', { message: 'Your rhythm has been edited.' });
      }
    },
    async saveTodo() {
      const {
        newTodo, newTodoProject, newTodoMotive, timeExpected, timeNeeded, dueDate, category,
      } = this;
      if (!newTodo) return;
      if (!this.todo) {
        this.$emit('add', {
          newTodo, newTodoProject, newTodoMotive, timeExpected, timeNeeded, dueDate, category,
        });
        this.newTodo = '';
        this.newTodoProject = '';
        this.newTodoMotive = '';
        this.timeExpected = '';
        this.timeNeeded = '';
        this.dueDate = '';
        this.category = '';
      } else {
        this.$emit('update', {
          newTodo, newTodoMotive, newTodoProject, timeNeeded, timeExpected, dueDate, category,
        });
      }
    },
    async setTodoData() {
      if (!this.todo) return;
      const {
        newTodo, newTodoProject, newTodoMotive, timeExpected, timeNeeded, dueDate, category,
      } = this.todo;

      if (newTodoProject) {
        const { name } = await this.$store.dispatch('loadProjects', newTodoProject);
        this.newTodoProject = name;
      }
      if (newTodoMotive) {
        const { text } = await this.$store.dispatch('loadMotives', newTodoMotive);
        this.newTodoMotive = text;
      }
      this.newTodo = newTodo;
      this.newTodoProject = newTodoProject;
      this.newTodoMotive = newTodoMotive;
      this.timeExpected = timeExpected;
      this.timeNeeded = timeNeeded;
      this.dueDate = dueDate;
      this.category = category;
    },
  },
  watch: {
    todo(newValue) {
      if (newValue) this.setTodoData();
      else {
        this.newTodo = '';
        this.newTodoMotive = '';
        this.newTodoProject = '';
        this.timeExpected = '';
        this.timeNeeded = '';
        this.dueDate = '';
        this.category = '';
      }
    },
  },
  props: {
    pageColor: String,
    doneUntil: Number,
  },
};
</script>

<style lang="stylus" scoped>

.leftButton
  position: absolute
  left:0
  margin-left: 30px
  bottom: 30px

.rightButton
  position: absolute
  right:0
  margin-right: 30px
  bottom: 30px

*
  outline: none
  border: none
  background-color: transparent

  h1
    margin-top: 45px
    margin-right: 30px
    margin-left: 30px
    margin-bottom: 30px
    font-family: operetta-8, serif
    font-weight: 700
    font-style: normal
    text-transform: lowercase
    text-align: left
    font-size: 30

  p
    text-align: left
    margin-right: 30px
    margin-left: 30px
    margin-bottom: 30px

.button
  border: none
  align-items: center
  font-size: 8px
  cursor: pointer
  font-family: futura-pt, sans-serif
  font-weight: 400;
  font-style: normal
  text-transform: uppercase
  outline: none

.plus
  padding: 7px
  filter: drop-shadow(0px 0px 1px #1017FF)
  &:focus
    color: white
    background-color: transparent
    border: none
    outline: none

  &:active
    color: white
    background-color: transparent
    border: none
    outline: none

  &:hover
    color: white
    background-color: transparent
    border: none
    outline: none

</style>
